module.exports = __webpack_public_path__ + "static/media/imageError1.cf9e67c8.png";